export default function HeroSection() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative w-full min-h-[80vh] flex items-center justify-center bg-black">

      {/* Subtle grain texture overlay */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none"
        style={{ backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='1'/%3E%3C/svg%3E\")", backgroundRepeat: "repeat", backgroundSize: "128px" }}
      />

      {/* Content — vertically centered */}
      <div className="relative z-10 w-full flex flex-col items-center text-center px-6 md:px-10 pt-16 pb-10">

        {/* Eyebrow */}
        <p
          className="text-white/40 text-[13px] tracking-[0.4em] uppercase mb-6"
          style={{ fontFamily: "'Barlow', sans-serif" }}
        >
          Est. 2025 &mdash; Bay Area, CA
        </p>

        {/* Logo */}
        <div className="w-full max-w-2xl md:max-w-3xl mx-auto mb-4">
          <img
            src="https://static.readdy.ai/image/2f7bf1de0c4b28d33f2b00b2a6c4bf32/d4ec4603b016ea4a0be1fedf06999f05.png"
            alt="The Philadelphia Sandwich Company"
            className="w-full h-auto object-contain"
          />
        </div>

        {/* Divider */}
        <div className="flex items-center gap-4 mb-4 w-full max-w-xs">
          <div className="flex-1 h-px bg-white/15" />
          <i className="ri-star-fill text-white/20 text-[8px] w-3 h-3 flex items-center justify-center"></i>
          <div className="flex-1 h-px bg-white/15" />
        </div>

        {/* Tagline */}
        <p
          className="text-white/60 text-sm md:text-base leading-relaxed max-w-sm mb-6"
          style={{ fontFamily: "'Barlow', sans-serif" }}
        >
          Where East Coast flavors and tradition meet West Coast style — to the last bite.
        </p>

        {/* CTAs */}
        <div className="flex items-center gap-4 flex-wrap justify-center">
          <button
            onClick={() => handleScroll("#menu")}
            className="bg-white text-black text-xs tracking-[0.2em] uppercase font-bold px-7 py-4 hover:bg-white/90 transition-all duration-200 cursor-pointer whitespace-nowrap rounded-sm"
            style={{ fontFamily: "'Barlow', sans-serif" }}
          >
            Explore Menu
          </button>
          <button
            onClick={() => handleScroll("#story")}
            className="border border-white/30 text-white text-xs tracking-[0.2em] uppercase font-bold px-7 py-4 hover:border-white hover:bg-white/5 transition-all duration-200 cursor-pointer whitespace-nowrap rounded-sm"
            style={{ fontFamily: "'Barlow', sans-serif" }}
          >
            Our Story
          </button>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 animate-bounce">
        <div className="w-px h-8 bg-white/20" />
        <i className="ri-arrow-down-line text-white/20 text-sm w-4 h-4 flex items-center justify-center"></i>
      </div>
    </section>
  );
}